import { createSvgSpriteIcon } from '@edikk-edikk/svg-icon';
import { IconMonoNameListType } from '#src/svg/icon-name-mono-list';

const AppSvgSpriteMonoIcon = createSvgSpriteIcon<IconMonoNameListType>('/builds/svg/sprite-mono.svg');

export { AppSvgSpriteMonoIcon };
